import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/user/selectors";
import { adminLevelFour } from "../../../../../redux/admin-level-four/action";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../components/PageLoader";
import { settings } from "../../../../../redux/settings/actions";
import { selectAdminLevelFourCreatedItem, selectAdminLevelFourDeletedItem, selectAdminLevelFourListItems, selectAdminLevelFourUpdatedItem } from "../../../../../redux/admin-level-four/selector";
import UploadCommonModal from "../../../../../models/upload-common-modal";

const GlobalAdminLevelsFour = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const result = useSelector(selectCurrent)
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [categoriesComparisonData, setCategoriesComparisonData] = useState<any>();
    const [categoriesListData, setAdminLevelOneListData] = useState<any>();
    const [uploadFor, setUploadFor] = useState('create');
    const [showComparisonPopup, setShowComparisonPopup] = useState<boolean>(false);
    const { header, footer, currency } = result
    const listGlobaladminLevelFourData = useSelector(selectAdminLevelFourListItems)
    const createAdminLevelOneData = useSelector(selectAdminLevelFourCreatedItem)
    const compareAdminLevelOneData = useSelector(selectAdminLevelFourCreatedItem)
    const updateAdminLevelOneData = useSelector(selectAdminLevelFourUpdatedItem)
    const deleteAdminLevelOneData = useSelector(selectAdminLevelFourDeletedItem)
    const [columnDefs, setColumnDefs] = useState({});
    const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);
    const { getUploadModal } = useAppSelector(selectCurrent)
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: "Sl",
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: "Sl",
                cellRenderer(params: any) {
                    return parseInt(params.node.id, 10) + 1;
                },
            },

            {
                field: "GlobalAdminLayer1Name",
                headerName: "Global Admin Layer 1 Name",
                searchField: "GlobalAdminLayer1Name",
                sortable: true,
                filter: true,
                filterType: "text",
            },
            {
                field: "GlobalAdminLayer2Name",
                headerName: "Global Admin Layer 2 Name",
                searchField: "GlobalAdminLayer2Name",
                sortable: true,
                filter: true,
                filterType: "text",
            },
            {
                field: "ParentAdminLayerName",
                headerName: "Parent Admin Layer Name",
                searchField: "ParentAdminLayerName",
                sortable: true,
                filter: true,
                filterType: "text",
            },

            {
                field: "ParentAdminLayerCode",
                headerName: "Parent Admin Layer Code",
                searchField: "ParentAdminLayerCode",
                sortable: true,
                filter: true,
                filterType: "text",
            },

            {
                field: "Name",
                headerName: "Name",
                searchField: "Name",
                sortable: true,
                filter: true,
                filterType: "text",
            },

            {
                field: "StdCode",
                headerName: "StdCode",
                searchField: "StdCode",
                sortable: true,
                filter: true,
                filterType: "text",
            },
        ]);
    };

    const fetchadminLevelFour = async () => {
        await dispatch(adminLevelFour.resetAction({ actionType: 'list' }))
        await dispatch(adminLevelFour.list({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/admin-layers-4/fetch`,
            entity: 'adminLevelThree',
            jsonData:
            {
                "Context": {},
                "Records": [
                    {}
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalAdminLayer4Id",
                    "SortOrder": "desc"
                }
            }
        }))
    }

    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleSelect = (data: any) => {
    }

    const handleEdit = (data: any) => {
        navigate(`${data.GlobalAdminLayer4Id}`)
    }

    const handleSearch = async (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column || data?.searchCriteriaList,
                FieldText: data?.column || data?.searchCriteriaList,
                FieldType: 'text',
                FilterOperatorId: data?.filterOperatorId || 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        await dispatch(adminLevelFour.resetAction({ actionType: 'list' }))
        await dispatch(adminLevelFour.list({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/admin-layers-4/fetch`,
            entity: 'adminLevelFour',
            jsonData:
            {
                "Context": {},
                "Records": [
                    {}
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalDBNDomainId",
                    "SortOrder": "desc",
                    "Searches": searchCriteria,
                }
            }
        }));
    }


  const handleUploadClose = () => {
    dispatch(settings.set({ getUploadModal: 'close' }))
  }
    const additionButtons: any = [
        {
            name: (
                <div className="flex items-center gap-2">
                    {/* Plus Icon */}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M12 5V19M5 12H19"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            ),
            callback: () => handleAdd(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
                    <title>Import Categories</title>
                    <path d="M3.00012 14L3.23397 14.6626C4.14412 17.2413 4.5992 18.5307 5.63754 19.2654C6.67588 20 8.04322 20 10.7779 20H13.2224C15.957 20 17.3244 20 18.3627 19.2654C19.401 18.5307 19.8561 17.2413 20.7663 14.6626L21.0001 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M12.0001 14V4M12.0001 14C11.2999 14 9.99165 12.0057 9.50012 11.5M12.0001 14C12.7003 14 14.0086 12.0057 14.5001 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            // name: 'Import Categories',
            callback: () => handleUploadCategoriesClick(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            // name: 'Reload',
            callback: () => handleReloadData(),
        },
    ];

    const handleReloadData = () => {
        fetchadminLevelFour();
    }

    const handleUploadCategoriesClick = () => {
        setUploadFor('create')
        dispatch(settings.set({ getUploadModal: 'open' }))
    };
  const handleUploadClick = async (data: any) => {
    const frmData = new FormData();
    frmData.append(
      'formFile',
      data
    );
    await dispatch(adminLevelFour.resetAction({ actionType: 'uploadCreate' }))
    await dispatch(adminLevelFour.uploadCreate({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/admin-layers-4/upload`,
      entity: 'uploadAdminLevelFour',
      jsonData:
        frmData
    })).then(() => {
      toast.info(
        'Categories uploading is in progress',
      );
      handleUploadClose()
    }).then(() => {
      fetchadminLevelFour();
    })
  };
    const handleCompareCategoriesClick = () => {
        setUploadFor('compare')
        dispatch(settings.set({ getUploadModal: 'open' }))
    };


    const handleDelete = async (data: any) => {
        await dispatch(adminLevelFour.resetAction({ actionType: 'delete' }))
        await dispatch(adminLevelFour.delete({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/admin-layers-4/delete`,
            entity: 'adminLevelFour',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.GlobalAdminLayer4Id

                    }
                ]
            }
        })).then(() => {
            fetchadminLevelFour();
        });
    }


    useEffect(() => {
        const searchCriteria: any = listGlobaladminLevelFourData?.result?.items
            ?.filter((item: any) => item?.Message?.SpecificationAttributeName) // Filter out items with falsy SpecificationAttributeName
            ?.map((item: any) => ({
                FieldName: item.Message.SpecificationAttributeName,
            }));
        setSearchCriteriaList(searchCriteria)
    }, [listGlobaladminLevelFourData]);

    useEffect(() => {
        if (listGlobaladminLevelFourData?.isSuccess) {
            setAdminLevelOneListData(listGlobaladminLevelFourData)
            dispatch(adminLevelFour.resetAction({ actionType: 'list' }))
        }
    }, [listGlobaladminLevelFourData]);

    useEffect(() => {
        if (createAdminLevelOneData?.isSuccess) {
            dispatch(adminLevelFour.resetAction({ actionType: 'create' }))
            fetchadminLevelFour();
            toast.info('Routing Model created successfully.')
        }
    }, [createAdminLevelOneData]);

    useEffect(() => {
        if (updateAdminLevelOneData?.isSuccess) {
            dispatch(adminLevelFour.resetAction({ actionType: 'update' }))
            toast.info('Routing Model updated successfully.')
        }
    }, [updateAdminLevelOneData]);

    useEffect(() => {
        if (deleteAdminLevelOneData?.isSuccess) {
            dispatch(adminLevelFour.resetAction({ actionType: 'delete' }))
            toast.info('Routing Model deleted successfully.')
        }
    }, [deleteAdminLevelOneData]);

    useEffect(() => {
        if (compareAdminLevelOneData?.isSuccess) {
            setCategoriesComparisonData(compareAdminLevelOneData)
            setShowComparisonPopup(true)
            dispatch(listGlobaladminLevelFourData.resetAction({ actionType: 'uploadCompare' }))
            // toast.info('Comparison completed successfully.')
        }
    }, [compareAdminLevelOneData]);

    useEffect(() => {
        createColumnDefs()
        fetchadminLevelFour()
        setShowComparisonPopup(false)
        dispatch(adminLevelFour.resetAction({ actionType: 'create' }))
        dispatch(adminLevelFour.resetAction({ actionType: 'uploadCreate' }))
        dispatch(adminLevelFour.resetAction({ actionType: 'uploadCompare' }))
        dispatch(adminLevelFour.resetAction({ actionType: 'update' }))
        dispatch(adminLevelFour.resetAction({ actionType: 'delete' }))
    }, [pageData, pageSize])

    return (
        <>
            {uploadFor === 'create' && getUploadModal == 'open' && <UploadCommonModal title='Import Categories' onSubmit={handleUploadClick} handleClose={handleUploadClose} />},

            {listGlobaladminLevelFourData?.isLoading ||
                createAdminLevelOneData?.isLoading ||
                updateAdminLevelOneData?.isLoading ||
                deleteAdminLevelOneData?.isLoading ||
                compareAdminLevelOneData?.isLoading ? <PageLoader /> :
                <Table
                    columnData={columnDefs}
                    rowData={categoriesListData?.result?.items}
                    enableFilter={true}
                    setPageData={setPageData}
                    setPageSize={setPageSize}
                    paginationData={categoriesListData?.result?.pagination}
                    onSearch={handleSearch}
                    searchCriteriaList={searchCriteriaList}
                    onSelect={handleSelect}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    additionButtons={additionButtons}
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'GlobalAdminLayer4Id',
                    }}
                    headingName="Global Admin Level Four"
                />
            }
        </>
    );
};

export default GlobalAdminLevelsFour;

